import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/tile-calculator',
  component: () => import('../../routes/TileCalculator.svelte'),
  card: {
    id: 'tile-calculator',
    title: 'Tile Calculator',
    description:
      'Estimate the number of tiles and boxes needed to cover a floor or wall. Supports straight, diagonal, and herringbone patterns with realistic waste factors.',
    icon: 'grid_view',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/tile-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Tile Calculator – Estimate Tiles and Boxes for Any Room',
    description:
      'Free tile calculator. Find how many tiles and boxes you need for any floor or wall. Supports 6 common tile sizes and 3 installation patterns with accurate waste factors.',
  },
};

export default meta;